module.exports = __webpack_public_path__ + "img/success.e343fb8a.png";